var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorState = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 4,
  width: 32,
  height: 21,
  rx: 1,
  fill: "#ECA57E"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 8,
  width: 40,
  height: 27,
  rx: 1,
  fill: "#F2C1A6"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 48,
  height: 31,
  rx: 1,
  fill: "#F9E2D6"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorState);
export { ForwardRef as ReactComponent };